import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { MuiThemeProvider } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

// Custom Inputs
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import InnerBar from './InnerBar';
import MetaBox from './inputs/MetaBox'
import TextInput from './inputs/TextInput'

import {
  is_logged_on,
  is_validating,
  theme
} from "../helpers"

 import {
   LocalForm,
   actions
} from 'react-redux-form'

import {
  isRequired,
  validateEmailType
} from "../validators"

import {
  get_buser,
  create_buser,
  update_buser,
  reset_buser,
  clear_buser,
} from '../actions'

const mapStateToProps = state => {
  const { buser, errors, fetching_single, fetched_single, must_redirect } = state.buser
  return {
    buser,
    errors,
    fetching_single,
    fetched_single,
    must_redirect,
    current_user: state.auth.current_user.data,
  }

}

const mapDispatchToProps = dispatch => {
  return {
    getBuser: buser_id => dispatch( get_buser(buser_id) ),
    createBuser: values => dispatch( create_buser(values) ),
    updateBuser: (buser_id, values) => dispatch( update_buser(buser_id, values) ),
    resetBuser: () => dispatch( reset_buser() ),
    clearBuser: () => dispatch( clear_buser() ),
  };
};

class ConnectedBuserForm extends React.Component {
  state = {
    actionName: '',
    nameValid: true,
    surnameValid: true,
    emailValid: true,

    formData: null,

    showDialog: false,
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  checkValid() {
    this.formDispatch( actions.setDirty('buser.name') )
    this.formDispatch( actions.setDirty('buser.surname') )
    this.formDispatch( actions.setDirty('buser.email') )

    const isValid = this.state.formData.$form.valid
    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }
    return isValid
  }

  handleSubmit(inValues) {
    let values = {
      ...inValues
    }

    if (this.state.actionName === "create") {
      this.props.createBuser(values)
    } else {
      const { buser_id } = this.props
      this.props.updateBuser(buser_id, values)
    }
  }

  handleUpdate(form) {
    const { name, surname, email } = form
    this.setState({formData: form})

    this.setState({
      nameValid: (name.pristine || name.valid),
      surnameValid: (surname.pristine || surname.valid),
      emailValid: (email.pristine || email.valid || this.props.actionName === 'update'),
    })
  }

  resetView() {
    const { actionName } = this.props
    const { clearBuser, buser, getBuser } = this.props
    clearBuser()
    this.setState({ actionName })
    if ( actionName === 'update') {
      const { buser_id } = this.props
      if ( buser.id !== buser_id ) {
        getBuser(buser_id)
      }
    }
  }

  componentWillMount() {
    this.resetView()
  }

  componentWillUpdate(prevProps, prevState) {
    const { actionName, must_redirect } = this.props
    if (this.state.actionName !== actionName ) {
      return this.resetView()
    }
    if (must_redirect && !prevProps.must_redirect) {
      window.showSnackbar('success', 'Buser has been saved.')
    }
  }

  hideDialog() {
    this.setState({showDialog: false, showRevokeDialog: false})
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { actionName, must_redirect } = this.props

    if ( actionName === 'create' && must_redirect && this.props.buser.id ) {
      return <Redirect to={`/users/${this.props.buser.id}/edit`} />
    }

    if ( actionName === 'update' && !this.props.buser.id ) {
      return ''
    }

    const {
      name, surname, email, id,
      created_at, updated_at
    } = this.props.buser
    const { fetching_single } = this.props

    let initialState
    if (actionName === "create") {
      initialState = {
        name: '',
        surname: '',
        email: '',
      }
    } else {
      initialState = {
        name,
        surname,
        email,
      }
    }

    const actionButtons = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          disabled={(false && !this.state.formValid) || fetching_single}
          onClick={e => {
            e.preventDefault()
            this.checkValid()
            this.formDispatch( actions.submit('buser'))
          }}>Save</CustomOutlinedButton>
      </div>
    )

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={24} justify="space-between" className={fetching_single ? 'long_saving' : ''}>

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <div className="d-flex justify-content-between mb-40">
              <Typography className="fw-bold h4">
                {this.props.headTitle || "User"}
              </Typography>

              { actionButtons }

            </div>
          </Grid>

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <LocalForm
              model="buser"
              className="collection-item"
              initialState={initialState}
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onUpdate={(form) => this.handleUpdate(form)}
              onSubmit = {(values) => this.handleSubmit(values)}
            >

              <Paper use="name" className="mb-24 innerbar">
                <InnerBar text="User Data" />
                <div className="pl-24 pr-24 pt-24 pb-24">

                  {
                    actionName === 'create' ? (
                      <React.Fragment>
                        <TextInput
                          id="buser-email"
                          model="buser.email"
                          required
                          placeholder="Email"
                          error={!this.state.emailValid}
                          helperText={this.state.emailValid ? "Enter Email (cannot change)*" : "A valid email is required *"}
                          validators={{
                            required: (val) => {
                              return validateEmailType(val)
                            }
                          }}
                        />
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <Typography className="h6 mt-32 mb-12">Email</Typography>
                        <TextInput
                          id="buser-email"
                          model="buser.email"
                          nocontrol
                          placeholder="User Email"
                          helperText="User Email *"
                          value={this.props.buser.email}
                        />
                      </React.Fragment>
                    )
                  }

                  <TextInput
                    id="buser-name"
                    model="buser.name"
                    required
                    placeholder="Name"
                    helperText={this.state.nameValid ? "Enter Name *" : "Name is required *"}
                    error={!this.state.nameValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                  <TextInput
                    id="buser-surame"
                    model="buser.surname"
                    placeholder="Surname"
                    helperText={this.state.surnameValid ? "Enter Surname *" : "Surname is required *"}
                    error={!this.state.surnameValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                </div>
              </Paper>
            </LocalForm>

            <Hidden smDown>
              <div className="d-flex justify-content-end mt-40">
                { actionButtons }
              </div>
            </Hidden>
          </Grid>

          { actionName === "update" && (
            <Grid item xs={12} md={4} className="will-change3">

              <Paper>
                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">

                    <MetaBox
                      title="ID"
                      value={id}
                    />
                    <MetaBox
                      title="Created on"
                      value={new Date(created_at).toLocaleString()}
                    />
                    { updated_at && (<MetaBox
                      title="Modified on"
                      value={new Date(updated_at).toLocaleString()}
                    />)}
                  </div>
                </div>

              </Paper>

            </Grid>
          )}
        </Grid>

      </MuiThemeProvider>
    )
  }
}

const BuserForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedBuserForm)
export default BuserForm



// WEBPACK FOOTER //
// ./src/js/components/BuserForm.js